<template>
    <div>
    <h2> Desert Ruin:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg','Desert Ruin')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/258079831/PPWJJ84xJ-Zh6hVKr276GA/original.jpg?163829248055" target="_blank">Map</a><br/>
    The Desert Ruin is the medium difficulty encounter with a CR of 8 on floor 2. It is arena style, so monsters will spawn one after another.
    
    <v-row>
        <v-col>
            <img id="Desert Ruin" :src="require('../../../assets/Annotated_Desert_Ruin.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place on the prime material plane.</li>
            <li>The area is covered in a weak sandstorm, and players can only see 40 feet.</li>
            <li>The ceiling is an unmeasurable height, however if players ascend more than 40 feet they risk getting lost and hurt by the sandstorm. If a player goes above 40 feet they must make a survival check each round DC 16+2 per 10 feet over 40 feet they are, +1 per round spent above 40 feet. If they fail they become lost, unable to act for 1d3 rounds, at which point they reappear 40 feet above a random area of the map, and take 3d6 damage each round they are lost.</li>
            <li>Map is 30x30</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>                
                <li>Monster Spawns: Red</li>
                <li>Terrain of Note: White</li>
            </ul>                 
        </ul>
        <br/><br/>

        <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 8: </b> </li>
            First wave appears the moment players enter arena            
            <ul>
                <li><b>1) Giant Scarab CR 6: </b> Flies in from spawnpoint 1</li>
                <li><b>2) 2x Mummy CR 5: </b> Walk in from spawnpoint 4</li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 9: </b> </li>
            Wave 2 begins once both mummies or the giant scarb from wave 1 are slain.
            <ul>
                <li><b>1) 4x Ratfolk Troubleshooter CR 5: </b> enters from spawnpoint 3, all of them enter after drinking their invisibilty potions.</li>
            </ul>
            <br/>
            <li><b>Wave 3 CR 10: </b> </li>
            Wave 3 begins once 3/4 ratfolk troubleshooters are dead.
            <ul>
                <li><b>1) Lamia Matriarch CR 8: </b> Enters from spawnpoint 4 (alt 3), Lamia Matriarch enters having already cast mage armor on herself. Spends first 2 rounds casting Mirror Image and haste then attacks.</li>
                <li><b>2) 2x Remorhaz CR 7: </b> Enters from spawnpoint 1 and 2 immediately attacking party.</li>
            </ul>
            <br/>
            <li><b>Wave 4 CR 12: </b> </li>
            Begins one full round after all monsters from wave 3 are dead.
            <ul>
                <li><b>Mummy Lord CR 10: </b> Enters from spawnpoint 4 (alt 3). Enters having already cast Divine Power, spends next rounds buffing as it feels it needs before attacking</li>
                <li><b>2x girtablilu CR 8: </b> Enter from spawnpoint 1 (alt 2).</li>
            </ul>
            <br/>
            <li><b>Wave 5 CR 13: </b> </li>
            Wave 5 begins 3 full rounds after the 2/3 monsters from wave 4 are slain.
            <ul>
                <li><b>Emperor Scorpion CR 11: </b> unborrows from ground from spawnpoint 4, if player is in area treat it as using ambush pit ability.</li>      
                <li><b>Death Worm Leviathan CR 11: </b> enters from spawnpoint 1, attempts to unburrow under players.</li>            
            </ul>
        </ul>
        <br/><br/>                        
        </v-col>
    </v-row>
    <h4>Treasure:</h4>
        <ul>
            <li><b>1) Perk 125</b></li>
            <li><b>2) R+ Armor Enchantment 75</b></li>
            <li><b>3) Enchanted Typed Weapon 100: </b> A player can attempt a DC 23 craft or survival check to upgrade this into a R+ Enchanted Typed R+ Weapon 125, if they beat the dc by 4 or more they can increase it to an E+ Enchanted E+ Typed Weapon 150. If they beat the DC by 8 or more decrease the cost by 25 gold.</li>
            <li><b>4) Resurrective 125</b></li>
            <li><b>5) R+ Stats 50</b> A player can attempt a knowledge religion check dc 23 to aquire this.</li>
            <li><b>6) Spell/Maneuver 40</b></li>
            <li><b>7) stats 50</b></li>
            <li><b>8) 2-4 potions 25</b></li>
            <li><b>9) Spell/Maneuver 40</b></li>
            <li><b>10) Typed Spell/Maneuver 60</b></li>
            <li><b>11) Feat 125</b></li>
            <li><b>12) E+ Weapon Enchantment 100: </b> To aquire item player must first beat a dc 28 perception check to spot item and then spend a standard action digging it up.</li>
            <li><b>13) Weapon Enchantment 100</b></li>
            <li><b>14) Stats 50</b></li>
            <li><b>15) 2-4 Potions 25</b></li>
            <li><b>16) Resurrective 125 </b></li>
            <li><b>17) Armor Enchantment 100 </b></li>
            <li><b>18) Typed Spell/Maneuver 40: </b> Player can attempt a DC 23 disable device or knowledge religion to aquire item.</li>
            <li><b>19) Stats 50 </b></li>
            <li><b>20) 2-4 Potions 25: </b> Player can attempt a DC 18 disable device or knowledge religion to aquire item.</li>
            <li><b>21) Teamwork Feat 175: </b> To aquire item player must first beat a dc 23 perception check to spot item and then spend a standard action digging it up. </li>
            <li><b>M1) Medium Gold Pile: </b>  To aquire item player must first beat a dc 23 perception check to spot item, but can be picked up without digging it up.</li>            
            <li><b>C) 8 Stats Cursed Chest: </b> If players activate cursed chest it spawns a seps, and rewards a level up if it is defeated.</li>
        </ul>
        <br/><br/>        


        <h4>Terrain of Note: </h4>
        <ul>
            <li><b>1) Steep cliff: </b> A 30 ft cliff, requires a DC 22 climb check to scale.</li>
            <li><b>2) Ruined Building: </b> a ruined building with a 30-ft ceiling, while inside players are covered from the sandstorm.</li>
            <li><b>3) Small cliff: </b> A 15 ft cliff, requires a DC 15 climb check to scale.</li>
            <li><b>4) Small cliff: </b> A 15 ft cliff, requires a DC 15 climb check to scale.</li>
            <li><b>5) Small cliff: </b> A 20 ft cliff, requires a DC 20 climb check to scale.</li>
            <li><b>6) Small cliff: </b> A 20 ft cliff, requires a DC 25 climb check to scale.</li>
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>